export const GET_SECTORS = 'GET_SECTORS'
